import { color } from '../styles/avatar-base.css.js';
export { shape as SHAPE_CLASS, size as SIZE_CLASS } from '../styles/avatar-base.css.js';

/** The neutral unknown-state variant takes priority over any passed color. */
function colorClass(type, avatarColor) {
    return type === 'unknown' ? color.unknown : color[avatarColor ?? 'gray'];
}

export { colorClass };
//# sourceMappingURL=avatar-classes.js.map
